export default __webpack_public_path__ + "static/media/use-case-marketing.c322787c.gif";